import type { ProjectChartDatapoint } from '@/api/generated/model';
import {
  AI_PROFICIENCY_MONTHLY_MIN_BUCKETS,
  buildAiProficiencyWeeklyFallbackTrendQuery,
  getAiProficiencyMonthlyRollingTrendQuery,
} from '@/domains/pages/ai-proficiency/utils/rolling-trend-query';
import { countTrimmedChartBuckets, trimChartEmptyPan } from '@/domains/pages/shared/trim-chart-empty-pan';
import type { TrendQueryConfig } from '@/domains/pages/shared/trend-query';
import {
  AI_PROFICIENCY_PAGE_QUERY_OPTIONS,
  getAiProficiencyTimeRangeQueryKey,
} from '@/domains/pages/ai-proficiency/query-options';

export function buildAiProficiencyChartTrendQueryKey(trendQuery: TrendQueryConfig) {
  return {
    granularity: trendQuery.granularity,
    bucketKind: trendQuery.bucketKind,
    timeRange: getAiProficiencyTimeRangeQueryKey(trendQuery.time_range),
  };
}

export function resolveAiProficiencyMonthlyTrendQuery(
  stableNow: Date,
  effectiveNow: Date,
): TrendQueryConfig {
  return getAiProficiencyMonthlyRollingTrendQuery(stableNow, effectiveNow);
}

export function resolveWeeklyFallbackTrendQuery(
  monthlyOrgChart: ProjectChartDatapoint | undefined,
  monthlyTrendQuery: TrendQueryConfig,
): TrendQueryConfig {
  return buildAiProficiencyWeeklyFallbackTrendQuery(monthlyOrgChart, monthlyTrendQuery);
}

export function shouldFallbackToWeeklyRollingTrend(
  monthlyOrgChart: ProjectChartDatapoint | undefined,
  monthlyOrgQuerySucceeded: boolean,
): boolean {
  if (!monthlyOrgQuerySucceeded) return false;
  return countTrimmedChartBuckets(monthlyOrgChart) < AI_PROFICIENCY_MONTHLY_MIN_BUCKETS;
}

export function trimProficiencyChart(chart: ProjectChartDatapoint | undefined): ProjectChartDatapoint | null {
  if (!chart) return null;
  return trimChartEmptyPan(chart);
}

export { AI_PROFICIENCY_PAGE_QUERY_OPTIONS };
